import { Link, useParams } from "react-router-dom";
import { useBlog } from "../context/BlogContext";

export default function BlogPost() {
  const { id } = useParams();
  const { getPost } = useBlog();
  const post = getPost(id);

  if (!post) {
    return (
      <div className="page">
        <header className="page-header">
          <h1>Post not found</h1>
          <p>That entry may have been removed.</p>
          <Link to="/blog" className="btn btn-ghost">
            Back to blog
          </Link>
        </header>
      </div>
    );
  }

  return (
    <article className="page blog-post">
      <Link to="/blog" className="text-link back-link">
        ← Blog
      </Link>
      <header className="page-header">
        <time dateTime={post.date}>
          {new Date(post.date + "T12:00:00").toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </time>
        <h1>{post.title}</h1>
      </header>
      <div className="prose">
        {post.body.split("\n\n").map((para) => (
          <p key={para.slice(0, 32)}>{para}</p>
        ))}
      </div>
    </article>
  );
}
